import React, { Component } from 'react';
import './Item.css'
import ConfigWorkModal from 'component/element/ConfigWorkModal'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['Fixing Config']}</h3>
  			<ConfigWorkModal
          mode='form'
        />
  		</div>
  	)
  }

}
 
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu5.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/MenuWorkConfig/Item.js